export const AU_STATES = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS'];

export function isValidAuState(state: string): boolean {
  return AU_STATES.includes(state);
}
